import { ReactNode } from 'react'

import {
  Container,
  ReservableTabHeaderSubtitle,
  ReservableTabHeaderTitle,
} from '~/components/Restaurant/ReservableTabHeader/ReservableTabHeaderShards'

type ReservableTabHeaderProps = {
  title: ReactNode
  subtitle: ReactNode
}

export const ReservableTabHeader = ({ title, subtitle }: ReservableTabHeaderProps) => {
  return (
    <Container>
      <ReservableTabHeaderTitle>{title}</ReservableTabHeaderTitle>
      <ReservableTabHeaderSubtitle>{subtitle}</ReservableTabHeaderSubtitle>
    </Container>
  )
}
